/**
 * External depedencies
 */
import { omitBy, values } from 'lodash';

/**
 * Internal depedencies
 */
import setFilters from './set-filters';
import { getFilters } from 'state/ui/dashboard-filter/selectors';

export default (member) => (dispatch, getState) => {
	const state = getState();
	let filters = [...getFilters(state)];
	filters = values(omitBy(filters, { member }));

	return dispatch(setFilters(filters));
};
